import { FC, useEffect } from 'react';
import { init } from '@fullstory/browser';
import { useEnvironment } from 'services/environment';
import { useFullstoryCrossOriginIframes } from './useFullstoryCrossOriginIframes';

export const FullstoryProvider: FC = () => {
  const { name: env } = useEnvironment();
  const isActive = !['test', 'development'].includes(env);
  useFullstoryCrossOriginIframes(isActive);

  useEffect(() => {
    if (isActive) {
      // Scoped to actual embeds so /chat (hosts the Lumis widget, never
      // itself embedded) keeps its default cross-origin iframe handling.
      const isIFramed = window.self !== window.top;
      init({
        orgId: 'stw',
        ...(isIFramed ? { recordOnlyThisIFrame: true } : {}),
      });
    }
  }, [isActive]);

  return null;
};
